import { z } from "zod";
import { BaseModelFields } from "./base-model";

export interface DeliveryFee extends BaseModelFields {
  deliveryType: string;
  name: string;
  description?: string | null;
  price: number; // BigDecimal
  isActive?: boolean | null;
}

// Request/Response DTOs (single source of truth for API contracts)
export interface DeliveryFeeCreateRequest {
  deliveryType: string;
  name: string;
  description?: string;
  price: number; // BigDecimal
  isActive: boolean;
}

export interface DeliveryFeeUpdateRequest {
  deliveryType?: string;
  name?: string;
  description?: string;
  price?: number; // BigDecimal
  isActive?: boolean;
}

// Delivery fee form schema for create operations
export const deliveryFeeCreateSchema = z.object({
  deliveryType: z.string().min(1, "Delivery type is required"),
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  price: z.number().min(1, "Price is required"),
  isActive: z.boolean().optional(),
});

// Delivery fee form schema for update operations
export const deliveryFeeUpdateSchema = z.object({
  deliveryType: z.string().min(1, "Delivery type is required").optional(),
  name: z.string().min(1, "Name is required").optional(),
  description: z.string().optional(),
  price: z.number().min(1, "Price is required").optional(),
  isActive: z.boolean().optional(),
});

// Delivery fee form values types
export type DeliveryFeeCreateFormValues = z.infer<
  typeof deliveryFeeCreateSchema
>;
export type DeliveryFeeUpdateFormValues = z.infer<
  typeof deliveryFeeUpdateSchema
>;
